export default "__VITE_ASSET__tKhz2aPR__"